import React from 'react';
import Div from '@pezeshk-book/ui-kit/div';
import Text from '@pezeshk-book/ui-kit/text';
import { ReplyCommentInterface } from './reply-comment.props';
import convertDate from '@utils/time/convert-date';
import { Card, CardBody } from '@pezeshk-book/ui-kit';

const ReplyComment = ({ id, user_name: userName, content, created_at: createdAt }: ReplyCommentInterface) => {
  return (
    <Card color="white" className={'rounded-lg mr-0 sm:mr-20 md:mr-36'}>
      <CardBody>
        <Div className={'justify-between'}>
          <Div className={'items-center gap-3'}>
            <Text typography={'xs'} type={'bold'}>{userName}</Text>
          </Div>
          <Text typography={'xs'} color={'grey.200'}>{convertDate(createdAt, 'dddd، DD MMMM YYYY')}</Text>
        </Div>
        <Text color={'grey.600'} typography={'sm'} align={'right'} className={'text-justify'}>{content}</Text>
      </CardBody>
    </Card>
  );
};

export default ReplyComment;
